import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import '../assets/css/components/ngss-content-tag.css'

const NgssContentTag = ({ title, text, type, size, onClick, linkPath }) => {
  const sizes = { small: 'sm', medium: 'md', large: 'lg' }

  const getSize = () => {
    return sizes[size] || 'md'
  }

  const getCursorClass = () => {
    if(onClick || linkPath){ return 'clickable' }
  }

  return(
    <div className='ngss-content-tag-wrapper'>
      {linkPath && <Link to={linkPath}></Link>}
      <span onClick={onClick} title={title} className={`label ngss-content-tag ${getCursorClass()} ${getSize()} ${type}`}>{text}</span>
    </div>
  )
}

const { string, func } = PropTypes
NgssContentTag.propTypes = {
  text:     string.isRequired,
  type:     string.isRequired,
  size:     string,
  onClick:  func,
  linkPath: string
}

export default NgssContentTag
